let user = null
let faq = null
let notification = null
let myCourses = null
let certificates = null
let certificateCheckInfo = null
let certificated = null
let certificatedData = null
let branches = null
export default {
    user,
    notification,
    myCourses,
    certificates,
    certificateCheckInfo,
    certificated,
    certificatedData,
    faq,
    branches
}